import { createFileRoute } from "@tanstack/react-router";
import { LegalPublicPage } from "@/components/legal/LegalPublicPage";
import { publicSitePath } from "@/lib/public-site";

export const Route = createFileRoute("/terminos")({
  component: TerminosPage,
  head: () => ({
    meta: [{ title: "Términos y Condiciones — tunegocio" }],
    links: [{ rel: "canonical", href: publicSitePath("/terminos") }],
  }),
});

function TerminosPage() {
  return (
    <LegalPublicPage
      title="Términos y Condiciones"
      type="terms_of_service"
    />
  );
}
